import { apiClient } from "../../../zodios/client";

type StaffOrganizationsResponse = Awaited<ReturnType<typeof apiClient.listStaffOrganizations>>;

export const getStaffOrganizationsInfiniteOptions = ({
  search,
  enabled = true,
}: { search?: string; enabled?: boolean } = {}) => ({
  queryKey: [{ entity: "staffOrganizations", scope: "infinite", search }],
  queryFn: async ({ pageParam }: { pageParam: number }) =>
    await apiClient.listStaffOrganizations({
      queries: { limit: 50, page: pageParam, ...(search ? { search } : {}) },
    }),
  initialPageParam: 1,
  getNextPageParam: (lastPage: StaffOrganizationsResponse, pages: StaffOrganizationsResponse[]) =>
    lastPage.next ? pages.length + 1 : undefined,
  enabled,
});
